export const APP_STORE_URL = "https://apps.apple.com/app/ehgezly/id6759931356";
export const PLAY_STORE_URL =
  "https://play.google.com/store/apps/details?id=com.ehgezly.app";

/** Pick App Store / Play Store link for mobile banners (e.g. home top bar). */
export function getMobileStoreUrl() {
  if (typeof navigator === "undefined") return APP_STORE_URL;
  const ua = navigator.userAgent || "";
  if (/android/i.test(ua)) return PLAY_STORE_URL;
  return APP_STORE_URL;
}

export const recTitlesAr = {
  "hair-&-nail-salon": "صيحات شعر نسائية رائجة",
  barbershop: "أفضل أنماط الشوارب",
  "tattoo-&-piercing-shops": "أفكار وإلهام للوشوم",
  "hair-removal": "ماذا تفعل الأخصائية التجميلية؟",
  "makeup-&-brows-&-lashes": "حواجب ورموش مثالية",
  "massage-&-aesthetic-medicine": "علاجات تجميلية",
};

export const recommendedItems = [
  {
    title: "Popular female hair trends",
    image: "/images/Rechair.jpg",
    slug: "hair-&-nail-salon",
    category: "Hair",
    categoryAr: "شعر",
  },
  {
    title: "Best Mustache Styles",
    image: "/images/beard.jpg",
    slug: "barbershop",
    category: "Barber",
    categoryAr: "حلاق",
  },
  {
    title: "Tattoo Ideas & Inspiration",
    image: "/images/tattoo.jpg",
    slug: "tattoo-&-piercing-shops",
    category: "Tattoo",
    categoryAr: "وشم",
  },
  {
    title: "What does esthetician do?",
    image: "/images/recesthetician1.jpg",
    slug: "hair-removal",
    category: "Skincare",
    categoryAr: "عناية",
  },
  {
    title: "Flawless Brows & Lashes",
    image: "/images/recbrowslashes.jpg",
    slug: "makeup-&-brows-&-lashes",
    category: "Brows",
    categoryAr: "حواجب",
  },
  {
    title: "Pet Services Benefits",
    image: "/images/recpet.jpg",
    slug: "massage-&-aesthetic-medicine",
    category: "Wellness",
    categoryAr: "عافية",
  },
];

export const HOME_PROMO_CARDS = [
  {
    key: "partner",
    to: "/for-business",
    icon: "partner",
    titleKey: "homePromoPartnerTitle",
    descKey: "homePromoPartnerDesc",
    ctaKey: "homePromoPartnerCta",
  },
  {
    key: "owner",
    to: "/ShopOwnerDashboard",
    icon: "owner",
    titleKey: "homePromoOwnerTitle",
    descKey: "homePromoOwnerDesc",
    ctaKey: "homePromoOwnerCta",
  },
];

export const HOME_EXPLORE_CARDS = [
  {
    key: "about",
    to: "/about",
    image: "/images/home-how-it-works.png",
    labelKey: "homeQuickHow",
    pageKey: "about",
    ctaKey: "homeQuickHowCta",
  },
  {
    key: "blog",
    to: "/blog",
    image: "/images/home-tips-trends.png",
    labelKey: "homeQuickTips",
    pageKey: "blog",
    ctaKey: "homeQuickTipsCta",
  },
  {
    key: "business",
    to: "/for-business",
    image: "/images/home-salons-clinics.png",
    labelKey: "homeQuickBusiness",
    pageKey: "business",
    ctaKey: "homeQuickBusinessCta",
  },
];

export const marketingI18n = {
  en: {
    brand: "ehgezly",
    listBiz: "List your business",
    howTitle: "How it works",
    howSteps: [
      {
        title: "Create account",
        description:
          "Quickly sign up so we can tailor some of recommendations to you.",
      },
      {
        title: "Choose service & filter your area",
        description: "Browse categories, then narrow results to your neighborhood.",
      },
      {
        title: "Pick a day, time & confirm",
        description: "Select the perfect slot and lock it in with a tap.",
      },
      {
        title: "Rate your appointment after you finish",
        description: "Share feedback to help the community discover top pros.",
        isFinal: true,
      },
    ],
    partnerTitle: "Why Partner with ehgezly?",
    partnerIntro:
      "We're transforming how beauty & wellness businesses operate in Egypt's digital-first economy.",
    partnerTrust: ["Built in Egypt", "Arabic & English support", "Free onboarding help"],
    partner: [
      {
        key: "revenue",
        title: "Increase Revenue",
        desc: "Partners see big booking growth in the first months. Fill empty hours with 24/7 availability.",
        metric: "24/7 bookings",
      },
      {
        key: "digital",
        title: "Digital Management",
        desc: "Goodbye WhatsApp chaos. Manage appointments, staff, and payments from one dashboard.",
        metric: "1 dashboard",
      },
      {
        key: "reach",
        title: "Reach More Clients",
        desc: "Show up where customers search. We bring nearby clients directly to your profile.",
        metric: "Local discovery",
      },
      {
        key: "payments",
        title: "Guaranteed Payments",
        desc: "Get paid automatically and securely. No more chasing or handling cash.",
        metric: "Secure payouts",
      },
      {
        key: "time",
        title: "Save Time",
        desc: "Automate confirmations, reminders, and payments. Focus on the client experience.",
        metric: "Auto reminders",
      },
      {
        key: "reviews",
        title: "Build Reputation",
        desc: "Collect reviews and grow your online presence. Quality gets you more bookings.",
        metric: "More reviews",
      },
    ],
    forBusinessHero: "Grow your salon with Ehgezly",
    forBusinessSub:
      "Accept bookings 24/7, manage your team, and reach new clients across Egypt.",
    shopOwnerTitle: "Sign in to ehgezly Business",
    shopOwnerIntro: "Bookings, revenue & team all in one place.",
    shopOwnerSignIn: "Sign In",
    recTitle: "Recommended for you",
    recSubtitle: "Tips, trends and inspiration for your next appointment.",
    recViewAll: "View all tips",
    downloadSubtitle: "Book beauty & wellness, when you need it",
    downloadTitle: "Get the Ehgezly app",
    mobileAppBannerTitle: "Ehgezly Free App",
    mobileAppBannerSubtitle: "Made for booking beauty pros on the go!",
    mobileAppBannerCta: "Open",
    mobileAppBannerDismiss: "Dismiss app banner",
    faqTitle: "We're Here to Help",
    faqSubtitleText:
      "Have any questions? Reach out to us or explore the answers below to get started.",
    faqSearchPh: "Search questions…",
    faqNoResults: "No questions match your search.",
    faqClientTitle: "For clients",
    faqBusinessTitle: "For business owners",
    faqContactTitle: "Still need help?",
    faqAiCta: "Ask AI Assistant",
    faqClient: [
      {
        q: "What is Ehgezly?",
        a: "Ehgezly is Egypt's leading booking platform for beauty and wellness. Discover services and book instantly.",
      },
      {
        q: "Can I book multiple services at once?",
        a: "Yes! Add each service to your appointment and confirm them together. Many partners offer bundle discounts.",
      },
      {
        q: "Is my payment information safe?",
        a: "We use encrypted transactions and never store full card details. Pay online with complete peace of mind.",
      },
      {
        q: "How do refunds work?",
        a: "Eligible refunds are issued within 5 to 7 business days. Check the provider's policy inside the booking summary.",
      },
      {
        q: "How do I join as a partner?",
        a: 'Click "Join as a business", fill out your information, and our onboarding team will activate your dashboard.',
      },
      {
        q: "Where can I get support?",
        a: "Use the AI assistant, email bookwithehgezly@gmail.com, or schedule a call with our success team.",
      },
    ],
    faqBusiness: [
      {
        q: "What is Ehgezly?",
        a: "At its core, Ehgezly is a booking and scheduling app, but we're so much more. We're a platform to help you run your business, your way. Ehgezly Biz: Schedule appointments, manage clients, promote your business, and process payments. Ehgezly for Customers: Clients near you can discover your business, book online, and manage their appointment from their phone. Your Ehgezly Profile acts as your website 24/7.",
      },
      {
        q: "What is a Marketplace and how does it help me?",
        a: "The Ehgezly Marketplace is where local clients looking to book a service find your Profile. Listing your business means clients can find and book you 24/7, without contacting you first.",
      },
      {
        q: "What is online booking?",
        a: "Using an appointment booking app allows clients to view and book your services online 24/7. Clients can see your availability and book a time that works for them, without calling or messaging you.",
      },
      {
        q: "Who is Ehgezly for?",
        a: "Ehgezly is business management, marketing, and scheduling software for businesses. Any small business that runs on appointments can run their business on Ehgezly.",
      },
    ],
    homeQuickHow: "How it works",
    homeQuickBusiness: "For salons & clinics",
    homeQuickTips: "Tips & trends",
    homeQuickHowCta: "Learn more",
    homeQuickBusinessCta: "Join now",
    homeQuickTipsCta: "Read blog",
    homeExploreMore: "Explore more",
    homePromoPartnerTitle: "Become a partner",
    homePromoPartnerDesc:
      "Reach more customers and achieve remarkable growth. Write your next chapter with Ehgezly.",
    homePromoPartnerCta: "Find out more",
    homePromoOwnerTitle: "Business owner login",
    homePromoOwnerDesc:
      "Sign in to manage bookings, your calendar, team, and revenue from your Ehgezly Business dashboard.",
    homePromoOwnerCta: "Sign in",
    pages: {
      about: {
        breadcrumb: "How it works",
        eyebrow: "For clients",
        title: "Book beauty & wellness in 4 steps",
        intro:
          "Everything you need to go from browsing services to confirming your appointment and leaving a review after.",
        sectionsLabel: "On this page",
        quickDesc:
          "Learn the booking flow from sign-up to review. Browse, book and rate nearby shops in Egypt.",
        cta: "Create free account in seconds",
        ctaTo: "/register",
        highlights: [
          { icon: "steps", title: "4-step timeline", desc: "Visual guide from account to finished appointment" },
          { icon: "search", title: "Find nearby shops", desc: "Filter by service type and your area" },
          { icon: "calendar", title: "Pick date & time", desc: "See real availability and confirm instantly" },
          { icon: "star", title: "Rate & discover", desc: "Help others find top-rated shops" },
        ],
      },
      business: {
        breadcrumb: "For salons & clinics",
        eyebrow: "For business owners",
        bannerTitle: "Built for salons & clinics",
        bannerIntro:
          "Reach more clients, fill your calendar, and run your business from one dashboard.",
        title: "Grow your salon with Ehgezly",
        intro:
          "List your business, accept online bookings 24/7, and manage your calendar, team, and clients from one dashboard.",
        sectionsLabel: "On this page",
        quickDesc:
          "Partner benefits, dashboard preview & sign-in. Reach more clients and fill your calendar in Egypt.",
        cta: "List your business in seconds",
        ctaTo: "/ListUrBussiness",
        highlights: [
          { icon: "growth", title: "6 partner benefits", desc: "Revenue, reach, payments, time saved & more" },
          { icon: "dashboard", title: "Live dashboard preview", desc: "See how your calendar looks on mobile" },
          { icon: "signin", title: "Business sign-in", desc: "Access your owner dashboard anytime" },
          { icon: "support", title: "Onboarding help", desc: "Arabic & English support when you join" },
        ],
      },
      blog: {
        breadcrumb: "Tips & trends",
        eyebrow: "Inspiration & guides",
        bannerTitle: "Inspiration for every appointment",
        bannerIntro:
          "Discover trending looks, expert tips, and guides for clients and beauty pros.",
        title: "Tips, trends & expert articles",
        intro:
          "Browse curated ideas for your next appointment, plus in-depth articles for salon owners and beauty pros.",
        sectionsLabel: "On this page",
        quickDesc:
          "Hair, barber, brows, wellness tips & articles. Fresh ideas for your next look in Egypt.",
        cta: "Book a service in seconds",
        ctaTo: "/",
        highlights: [
          { icon: "grid", title: "Recommended picks", desc: "6 trending topics with photos & guides" },
          { icon: "articles", title: "Salon articles", desc: "Growth, marketing & operations tips" },
          { icon: "tags", title: "Browse by topic", desc: "Filter articles by tag or search" },
          { icon: "book", title: "Deep-dive guides", desc: "Open full articles for each service type" },
        ],
      },
      faq: {
        breadcrumb: "FAQ",
        eyebrow: "Help center",
        bannerTitle: "We're here to help",
        bannerIntro:
          "Find answers for booking, payments, and running your salon on Ehgezly.",
        title: "Answers for clients and owners",
        intro:
          "Browse FAQs for bookings and running a salon. Ask the assistant on Support, or email and call from Contact.",
        sectionsLabel: "On this page",
        quickDesc: "Client and business FAQs.",
        cta: "Contact us",
        ctaTo: "/contact",
        highlights: [
          { icon: "clients", title: "For clients", desc: "Booking, payments, refunds and account help" },
          { icon: "owners", title: "For business owners", desc: "Marketplace, online booking and partnership" },
          { icon: "support", title: "AI assistant", desc: "Quick answers on the Support page" },
          { icon: "contact", title: "Talk to us", desc: "Email, phone and a message on Contact" },
        ],
      },
      team: {
        breadcrumb: "Team",
        eyebrow: "Meet Ehgezly",
        bannerTitle: "Small team. Big impact.",
        bannerIntro:
          "We're building Egypt's booking platform for beauty and wellness, one appointment at a time.",
        title: "Our vision and founder",
        intro:
          "Ehgezly started with a simple goal: save people time and make booking beauty services effortless across Egypt.",
        sectionsLabel: "On this page",
        quickDesc: "Founder story, platform benefits and how to reach us.",
        cta: "Contact us",
        ctaTo: "/support",
        highlights: [
          { icon: "people", title: "Founder story", desc: "Who we are and why we built Ehgezly" },
          { icon: "star", title: "Client benefits", desc: "Quick booking, fair prices and trusted reviews" },
          { icon: "growth", title: "Built in Egypt", desc: "Arabic and English for clients and salons" },
          { icon: "contact", title: "Get in touch", desc: "Partners, careers and support enquiries" },
        ],
      },
      privacy: {
        breadcrumb: "Privacy Policy",
        eyebrow: "Legal and trust",
        bannerTitle: "Your privacy matters",
        bannerIntro:
          "Clear, honest practices for how Ehgezly collects, uses, and protects your personal data.",
        title: "How we handle your information",
        intro:
          "We collect only what we need to run bookings, never sell your data, and give you meaningful control over your account.",
        sectionsLabel: "Quick overview",
        quickDesc: "Data collection, usage, sharing, security and your rights.",
        cta: "Contact privacy team",
        ctaTo: "/support",
        highlights: [
          { icon: "shield", title: "Data protection", desc: "Encryption, secure storage and access controls" },
          { icon: "lock", title: "Never sold", desc: "No selling personal data to advertisers or brokers" },
          { icon: "clients", title: "Minimal collection", desc: "Account, bookings and usage, only what's needed" },
          { icon: "contact", title: "Your rights", desc: "Update, export, unsubscribe or delete anytime" },
        ],
        summary: [
          { icon: "lock", title: "Never sold", desc: "Personal data is never sold to advertisers or data brokers." },
          { icon: "shield", title: "Secure by design", desc: "Encrypted in transit and stored on hardened infrastructure." },
          { icon: "clients", title: "You're in control", desc: "Update your profile, opt out of marketing, or request deletion." },
        ],
        tocLabel: "On this page",
        ctaTitle: "Questions about your data?",
        ctaDesc: "Reach our privacy team for data requests, account deletion, or policy questions.",
        ctaSecondary: "Delete account",
        ctaSecondaryTo: "/delete-account",
      },
      support: {
        breadcrumb: "Support",
        eyebrow: "Help center",
        bannerTitle: "Answers, instantly",
        bannerIntro:
          "Ask the Ehgezly assistant or browse FAQs, for clients and business owners across Egypt.",
        title: "Help yourself in seconds",
        intro:
          "Use the AI assistant for a quick answer, or open the FAQs below. To email or call a person, go to Contact.",
        sectionsLabel: "On this page",
        quickDesc: "AI assistant and FAQs for clients and owners.",
        cta: "Browse FAQs",
        ctaTo: "#support-faqs",
        highlights: [
          { icon: "support", title: "AI assistant", desc: "Ask about bookings, account, or the app" },
          { icon: "articles", title: "FAQs", desc: "Short answers for clients and owners" },
          { icon: "clients", title: "For clients", desc: "Appointments, payments and your profile" },
          { icon: "owners", title: "For business", desc: "Listing, dashboard and partner help" },
        ],
        tocLabel: "Ehgezly assistant",
        channelsLabel: "Ask the assistant",
        channelsLead: "Pick a topic or type a question. Email and phone live on the Contact page.",
        faqsLabel: "Browse FAQs",
        faqsLead: "Short answers for clients and business owners. Open a question below.",
        ctaTitle: "Need a person?",
        ctaDesc: "Email, call, or send a message. We reply within one business day.",
        ctaSecondary: "Contact us",
        ctaSecondaryTo: "/contact",
      },
      contact: {
        breadcrumb: "Contact",
        eyebrow: "Get in touch",
        bannerTitle: "We answer. Fast.",
        bannerIntro:
          "Email, phone, or a short message. The Ehgezly team in Cairo replies in Arabic or English.",
        title: "Talk to Ehgezly",
        intro:
          "Bookings, your account, or listing a salon. Send a note and we get back within one business day.",
        sectionsLabel: "On this page",
        quickDesc: "Email, phone, hours and a message form.",
        cta: "Send a message",
        ctaTo: "#contact-form",
        highlights: [
          { icon: "contact", title: "Email first", desc: "Best for bookings, accounts and details" },
          { icon: "phone", title: "Call the line", desc: "Urgent help during Cairo hours" },
          { icon: "clock", title: "One day reply", desc: "We read every message, Sat to Thu" },
          { icon: "owners", title: "Clients and owners", desc: "Same inbox for both, we route it" },
        ],
        emailLabel: "Email",
        emailValue: "bookwithehgezly@gmail.com",
        emailHint: "Attach screenshots if something broke in the app.",
        phoneLabel: "Phone",
        phoneValue: "+20 111 664 0224",
        phoneHint: "Sat to Thu, 10:00 to 20:00 Cairo time.",
        hoursLabel: "Hours",
        hoursValue: "Sat to Thu, 10:00 to 20:00",
        hoursHint: "Friday: email only. We reply next business day.",
        hoursExtra: "Cairo time (EET and EEST)",
        formTitle: "Send a message",
        formLead: "Opens your email app with the details filled in. Nothing is stored on this page.",
        nameLabel: "Your name",
        namePh: "Full name",
        emailFieldLabel: "Your email",
        emailPh: "you@email.com",
        topicLabel: "Topic",
        topics: [
          { value: "booking", label: "Booking or appointment" },
          { value: "account", label: "Account or login" },
          { value: "business", label: "List or manage a business" },
          { value: "payment", label: "Payments or refunds" },
          { value: "other", label: "Something else" },
        ],
        messageLabel: "Message",
        messagePh: "What happened, and what do you need?",
        submit: "Open in email",
        nextTitle: "What happens next",
        nextSteps: [
          "We read your note the same or next business day.",
          "Replies come from bookwithehgezly@gmail.com.",
          "Urgent? Call and keep your booking name handy.",
        ],
        reasonsTitle: "What we can help with",
        reasons: [
          { title: "Bookings", desc: "Times, cancellations, shops that did not confirm." },
          { title: "Your account", desc: "Login, password, profile, or deleting an account." },
          { title: "Partners", desc: "List a salon, dashboard access, or payout questions." },
          { title: "Privacy", desc: "Data requests or how we use your information." },
        ],
        basedIn: "Based in Cairo, Egypt",
        basedInDesc: "We build Ehgezly here. Arabic and English support.",
        followTitle: "Follow along",
        ctaTitle: "Want instant answers?",
        ctaDesc: "Support has the AI assistant and FAQs. No need to wait for email.",
        ctaSecondary: "Open Support",
        ctaSecondaryTo: "/support",
        ctaFaq: "View FAQs",
      },
      delete: {
        breadcrumb: "Delete account",
        eyebrow: "Account and data",
        bannerTitle: "Delete your account",
        bannerIntro:
          "Request permanent deletion. We wait 90 days before removing your data.",
        title: "Request account deletion",
        intro:
          "Submit the form below. We delete your account and data 90 days after the request.",
        sectionsLabel: "On this page",
        quickDesc: "Request form, 90 day wait, and what happens next.",
        cta: "Submit request",
        ctaTo: "#delete-form",
        highlights: [
          { icon: "clock", title: "90 days", desc: "We wait before permanent deletion" },
          { icon: "lock", title: "Confirm first", desc: "Type DELETE so the request is intentional" },
          { icon: "contact", title: "Email required", desc: "We match the request to your account" },
          { icon: "shield", title: "Your data", desc: "Read how we handle information on Privacy" },
        ],
        formTitle: "Deletion request",
        formLead: "Use the email on your Ehgezly account. Optional fields help us process the request.",
        emailLabel: "Email address",
        emailPh: "example@email.com",
        nameLabel: "Name (optional)",
        namePh: "Name as shown on the account",
        reasonLabel: "Reason (optional)",
        reasonPh: "Why do you want to delete your account?",
        confirmLabel: "Type DELETE to confirm",
        confirmWord: "DELETE",
        submit: "Submit request",
        submitting: "Submitting…",
        errorEmail: "Email is required",
        errorConfirm: "Please type DELETE to confirm",
        errorGeneric: "Something went wrong",
        successTitle: "Your request has been received.",
        successDesc: "Your account will be permanently deleted after 90 days. This request cannot be undone.",
        nextTitle: "What happens next",
        nextSteps: [
          "We confirm the email matches an Ehgezly account.",
          "Your account stays until 90 days have passed.",
          "Then we permanently delete the account and data.",
        ],
        noteTitle: "Before you send",
        noteDesc: "Bookings, saved shops, and profile data are removed with the account after 90 days.",
        ctaTitle: "Changed your mind?",
        ctaDesc: "Keep using Ehgezly, or read how we handle your data.",
        ctaSecondary: "Privacy Policy",
        ctaSecondaryTo: "/privacy",
        ctaContact: "Contact us",
      },
      ownerLogin: {
        bannerTitle: "Ehgezly Business",
        brandHeadline: "Run your salon from one place",
        bannerIntro:
          "Bookings, calendar, team, and revenue stay in sync — the moment a client reserves online.",
        benefitsTitle: "Inside your dashboard",
        benefits: [
          { icon: "calendar", title: "Live calendar", desc: "See openings, today’s schedule, and new requests instantly." },
          { icon: "history", title: "Booking history", desc: "Accept, reschedule, or mark appointments complete in seconds." },
          { icon: "analytics", title: "Analytics", desc: "Track revenue, bookings, and what’s driving growth." },
        ],
        noAccount: "Don't have a listing yet?",
        listBusiness: "List your business",
        partnerInfo: "Learn about partnering",
        credsTitle: "Your temporary login",
        credsHint: "Save these credentials — you can change your password after signing in.",
        signingIn: "Signing in…",
      },
    },
  },
  ar: {
    brand: "احجزلي",
    listBiz: "أضف نشاطك",
    howTitle: "كيف يعمل",
    howSteps: [
      {
        title: "أنشئ حساباً",
        description: "سجّل بسرعة لنخصص لك التوصيات المناسبة.",
      },
      {
        title: "اختر الخدمة وحدّد منطقتك",
        description: "استعرض الفئات ثم حدّد الحي الذي تفضله.",
      },
      {
        title: "اختر اليوم والوقت وأكد الحجز",
        description: "حدد الموعد المناسب مع جدولك وثبّت الحجز فوراً.",
      },
      {
        title: "قيّم موعدك بعد الانتهاء",
        description: "شارك رأيك لمساعدة المجتمع في اكتشاف أفضل المحترفين.",
        isFinal: true,
      },
    ],
    partnerTitle: "لماذا تشارك احجزلي؟",
    partnerIntro:
      "نحوّل طريقة عمل صالونات الجمال والعيادات في اقتصاد مصر الرقمي.",
    partnerTrust: ["صُنع في مصر", "دعم عربي وإنجليزي", "مساعدة في الانضمام"],
    partner: [
      {
        key: "revenue",
        title: "زيادة الإيرادات",
        desc: "نمو قوي في الحجوزات خلال الأشهر الأولى. املأ الساعات الفارغة بتوفّر 24/7.",
        metric: "حجز 24/7",
      },
      {
        key: "digital",
        title: "إدارة رقمية",
        desc: "ودّع فوضى الواتساب. أدر المواعيد والفريق والمدفوعات من لوحة واحدة.",
        metric: "لوحة واحدة",
      },
      {
        key: "reach",
        title: "وصول لعملاء أكثر",
        desc: "كن حاضراً حيث يبحث العملاء. نجلب العملاء القريبين إلى ملفك.",
        metric: "اكتشاف محلي",
      },
      {
        key: "payments",
        title: "مدفوعات مضمونة",
        desc: "استلم أموالك تلقائياً وبأمان. بدون مطاردة أو نقد.",
        metric: "دفع آمن",
      },
      {
        key: "time",
        title: "وفّر وقتك",
        desc: "أتمتة التأكيدات والتذكيرات والمدفوعات. ركّز على تجربة العميل.",
        metric: "تذكير تلقائي",
      },
      {
        key: "reviews",
        title: "بناء السمعة",
        desc: "اجمع التقييمات ونمِ حضورك الرقمي. الجودة تجلب حجوزات أكثر.",
        metric: "تقييمات أكثر",
      },
    ],
    forBusinessHero: "نمِّ صالونك مع احجزلي",
    forBusinessSub:
      "اقبل الحجوزات على مدار الساعة، أدر فريقك، واصل لعملاء جدد في مصر.",
    shopOwnerTitle: "سجّل الدخول إلى احجزلي للأعمال",
    shopOwnerIntro: "الحجوزات، الإيرادات وفريقك كلها من مكان واحد.",
    shopOwnerSignIn: "تسجيل الدخول",
    recTitle: "موصى به لك",
    recSubtitle: "نصائح وصيحات وإلهام لموعدك القادم.",
    recViewAll: "عرض كل النصائح",
    downloadSubtitle: "احجز خدمات الجمال والعافية وقتما تحتاج",
    downloadTitle: "حمّل تطبيق احجزلي",
    mobileAppBannerTitle: "تطبيق احجزلي المجاني",
    mobileAppBannerSubtitle: "مصمم لحجز خبراء الجمال أثناء التنقل!",
    mobileAppBannerCta: "فتح",
    mobileAppBannerDismiss: "إغلاق شريط التطبيق",
    faqTitle: "نحن هنا لمساعدتك",
    faqSubtitleText:
      "لديك أي أسئلة؟ تواصل معنا أو استكشف الإجابات أدناه للبدء.",
    faqSearchPh: "ابحث في الأسئلة…",
    faqNoResults: "لا توجد أسئلة مطابقة.",
    faqClientTitle: "للعملاء",
    faqBusinessTitle: "لأصحاب الأعمال",
    faqContactTitle: "ما زلت تحتاج مساعدة؟",
    faqAiCta: "اسأل المساعد الذكي",
    faqClient: [
      {
        q: "ما هو احجزلي؟",
        a: "احجزلي هو المنصة الرائدة لحجز خدمات الجمال والعافية في مصر. اكتشف الخدمات واحجز فورًا.",
      },
      {
        q: "هل يمكنني حجز عدة خدمات في وقت واحد؟",
        a: "نعم! أضف كل خدمة إلى موعدك وأكّدها معًا. يقدم العديد من شركائنا خصومات للحجوزات المجمعة.",
      },
      {
        q: "هل معلومات الدفع الخاصة بي آمنة؟",
        a: "نستخدم معاملات مشفرة ولا نخزن بيانات البطاقة. ادفع بأمان على منصتنا.",
      },
      {
        q: "كيف تعمل عملية الاسترداد؟",
        a: "تُصدر الاستردادات المؤهلة خلال 5 إلى 7 أيام عمل. راجع سياسة المزود داخل ملخص الحجز.",
      },
      {
        q: "كيف أنضم كشريك؟",
        a: 'انقر على "انضم كبزنس"، أدخل معلوماتك، وسيقوم فريقنا بتفعيل لوحة التحكم الخاصة بك.',
      },
      {
        q: "أين أحصل على الدعم؟",
        a: "استخدم المساعد الذكي، أو راسل bookwithehgezly@gmail.com، أو حدد مكالمة مع فريق النجاح.",
      },
    ],
    faqBusiness: [
      {
        q: "ما هو Ehgezly؟",
        a: "في جوهره، Ehgezly هو تطبيق حجز ومواعيد، ونحن أكثر من ذلك. نحن منصة لمساعدتك على إدارة عملك. احجزلي للأعمال: جدول المواعيد، إدارة العملاء، الترويج والمدفوعات. احجزلي للعملاء: العملاء يكتشفونك ويحجزون من هواتفهم. ملفك يعمل كموقعك 24/7.",
      },
      {
        q: "ما هو السوق وكيف يساعدني؟",
        a: "سوق Ehgezly هو المكان الذي يجد فيه العملاء المحليون ملفك ويحجزون. إدراجك يعني أن العملاء يمكنهم العثور عليك والحجز على مدار الساعة دون الاتصال بك أولاً.",
      },
      {
        q: "ما هو الحجز عبر الإنترنت؟",
        a: "يتيح تطبيق الحجز للعملاء عرض خدماتك والحجز أونلاين 24/7. يمكنهم رؤية توفرك وحجز وقت يناسبهم دون مكالمات أو رسائل.",
      },
      {
        q: "لمن Ehgezly؟",
        a: "Ehgezly برنامج إدارة وتسويق وجدولة للشركات. أي نشاط صغير يعتمد على المواعيد يمكنه إدارة أعماله على Ehgezly.",
      },
    ],
    homeQuickHow: "كيف يعمل",
    homeQuickBusiness: "للصالونات والعيادات",
    homeQuickTips: "نصائح وصيحات",
    homeQuickHowCta: "اعرف المزيد",
    homeQuickBusinessCta: "انضم الآن",
    homeQuickTipsCta: "اقرأ المدونة",
    homeExploreMore: "استكشف المزيد",
    homePromoPartnerTitle: "كن شريكاً",
    homePromoPartnerDesc:
      "اوصل لعملاء أكثر وحقق نمواً ملحوظاً. اكتب فصلك الجديد مع احجزلي.",
    homePromoPartnerCta: "اعرف المزيد",
    homePromoOwnerTitle: "دخول أصحاب الأعمال",
    homePromoOwnerDesc:
      "سجّل الدخول لإدارة الحجوزات والتقويم والفريق والإيرادات من لوحة احجزلي للأعمال.",
    homePromoOwnerCta: "تسجيل الدخول",
    pages: {
      about: {
        breadcrumb: "كيف يعمل",
        eyebrow: "للعملاء",
        title: "احجز الجمال والعافية في 4 خطوات",
        intro:
          "كل ما تحتاجه من تصفح الخدمات إلى تأكيد الموعد ثم تقييم تجربتك بعد الانتهاء.",
        sectionsLabel: "في هذه الصفحة",
        quickDesc:
          "تعرّف على خطوات الحجز من التسجيل إلى التقييم. تصفّح واحجز وقيّم محلات قريبة في مصر.",
        cta: "إنشاء حساب مجاني في ثوانٍ",
        ctaTo: "/register",
        highlights: [
          { icon: "steps", title: "جدول 4 خطوات", desc: "دليل مرئي من الحساب إلى انتهاء الموعد" },
          { icon: "search", title: "اعثر على محلات قريبة", desc: "فلترة حسب الخدمة ومنطقتك" },
          { icon: "calendar", title: "اختر الموعد", desc: "شاهد التوفر الحقيقي وأكّد فوراً" },
          { icon: "star", title: "قيّم واكتشف", desc: "ساعد الآخرين في إيجاد أفضل المحلات" },
        ],
      },
      business: {
        breadcrumb: "للصالونات والعيادات",
        eyebrow: "لأصحاب الأعمال",
        bannerTitle: "مصمم للصالونات والعيادات",
        bannerIntro:
          "اوصل لعملاء أكثر، املأ تقويمك، وأدر نشاطك من لوحة واحدة.",
        title: "نمِّ صالونك مع احجزلي",
        intro:
          "أضف نشاطك، استقبل الحجوزات أونلاين على مدار الساعة، وأدر التقويم والفريق والعملاء من لوحة واحدة.",
        sectionsLabel: "في هذه الصفحة",
        quickDesc:
          "مزايا الشراكة، معاينة اللوحة وتسجيل الدخول. اوصل لعملاء أكتر واملأ تقويمك في مصر.",
        cta: "أضف نشاطك في ثوانٍ",
        ctaTo: "/ListUrBussiness",
        highlights: [
          { icon: "growth", title: "6 مزايا للشركاء", desc: "إيرادات، وصول، مدفوعات، وقت أقل وأكثر" },
          { icon: "dashboard", title: "معاينة اللوحة", desc: "شاهد شكل التقويم على الجوال" },
          { icon: "signin", title: "دخول الأعمال", desc: "الوصول إلى لوحة المالك في أي وقت" },
          { icon: "support", title: "مساعدة الانضمام", desc: "دعم عربي وإنجليزي عند التسجيل" },
        ],
      },
      blog: {
        breadcrumb: "نصائح وصيحات",
        eyebrow: "إلهام ودلائل",
        bannerTitle: "إلهام لكل موعد",
        bannerIntro:
          "اكتشف الصيحات والنصائح والدلائل للعملاء ومحترفي الجمال.",
        title: "نصائح وصيحات ومقالات",
        intro:
          "تصفح أفكاراً لموعدك القادم، بالإضافة إلى مقالات متعمقة لأصحاب الصالونات ومحترفي الجمال.",
        sectionsLabel: "في هذه الصفحة",
        quickDesc:
          "شعر، حلاقة، حواجب، عافية ومقالات. أفكار جديدة لإطلالتك الجاية في مصر.",
        cta: "احجز خدمة في ثوانٍ",
        ctaTo: "/",
        highlights: [
          { icon: "grid", title: "اختيارات موصى بها", desc: "6 مواضيع رائجة مع صور ودلائل" },
          { icon: "articles", title: "مقالات للصالونات", desc: "نمو، تسويق وعمليات" },
          { icon: "tags", title: "تصفح حسب الموضوع", desc: "فلترة المقالات أو البحث" },
          { icon: "book", title: "دلائل تفصيلية", desc: "افتح مقالات كاملة لكل نوع خدمة" },
        ],
      },
      faq: {
        breadcrumb: "الأسئلة الشائعة",
        eyebrow: "مركز المساعدة",
        bannerTitle: "نحن هنا لمساعدتك",
        bannerIntro:
          "اعثر على إجابات للحجز والمدفوعات وإدارة صالونك على احجزلي.",
        title: "إجابات للعملاء وأصحاب الأعمال",
        intro:
          "تصفّح الأسئلة للحجز وإدارة الصالون. اسأل المساعد في الدعم، أو راسل واتصل من تواصل.",
        sectionsLabel: "في هذه الصفحة",
        quickDesc: "أسئلة العملاء والأعمال.",
        cta: "تواصل معنا",
        ctaTo: "/contact",
        highlights: [
          { icon: "clients", title: "للعملاء", desc: "حجز، مدفوعات، استرداد والحساب" },
          { icon: "owners", title: "لأصحاب الأعمال", desc: "السوق، الحجز أونلاين والشراكة" },
          { icon: "support", title: "المساعد الذكي", desc: "إجابات سريعة في صفحة الدعم" },
          { icon: "contact", title: "تكلم معنا", desc: "بريد، هاتف ورسالة في تواصل" },
        ],
      },
      team: {
        breadcrumb: "الفريق",
        eyebrow: "تعرّف على احجزلي",
        bannerTitle: "فريق صغير. تأثير كبير.",
        bannerIntro:
          "نبني منصة الحجز الأولى للجمال والعافية في مصر، موعداً تلو الآخر.",
        title: "رؤيتنا والمؤسس",
        intro:
          "بدأ احجزلي بهدف بسيط: توفير وقت الناس وجعل حجز خدمات الجمال سهلاً في أنحاء مصر.",
        sectionsLabel: "في هذه الصفحة",
        quickDesc: "قصة المؤسس، مزايا المنصة وكيفية التواصل معنا.",
        cta: "تواصل معنا",
        ctaTo: "/support",
        highlights: [
          { icon: "people", title: "قصة المؤسس", desc: "من نحن ولماذا أنشأنا احجزلي" },
          { icon: "star", title: "مزايا للعملاء", desc: "حجز سريع، أسعار واضحة وتقييمات موثوقة" },
          { icon: "growth", title: "صُنع في مصر", desc: "عربي وإنجليزي للعملاء والصالونات" },
          { icon: "contact", title: "تواصل معنا", desc: "شركاء، وظائف واستفسارات الدعم" },
        ],
      },
      privacy: {
        breadcrumb: "سياسة الخصوصية",
        eyebrow: "قانوني وثقة",
        bannerTitle: "خصوصيتك مهمة",
        bannerIntro:
          "ممارسات واضحة وصادقة حول كيفية جمع احجزلي لبياناتك الشخصية واستخدامها وحمايتها.",
        title: "كيف نتعامل مع معلوماتك",
        intro:
          "نجمع فقط ما نحتاجه لتشغيل الحجوزات، ولا نبيع بياناتك، ونمنحك تحكماً حقيقياً في حسابك.",
        sectionsLabel: "نظرة سريعة",
        quickDesc: "جمع البيانات، الاستخدام، المشاركة، الأمان وحقوقك.",
        cta: "تواصل مع فريق الخصوصية",
        ctaTo: "/support",
        highlights: [
          { icon: "shield", title: "حماية البيانات", desc: "تشفير، تخزين آمن وضوابط وصول" },
          { icon: "lock", title: "لا نبيع بياناتك", desc: "لا بيع للبيانات الشخصية للمعلنين أو الوسطاء" },
          { icon: "clients", title: "جمع محدود", desc: "حساب، حجوزات واستخدام، فقط ما يلزم" },
          { icon: "contact", title: "حقوقك", desc: "تحديث، تصدير، إلغاء اشتراك أو حذف في أي وقت" },
        ],
        summary: [
          { icon: "lock", title: "لا نبيع بياناتك", desc: "لا نبيع البيانات الشخصية للمعلنين أو وسطاء البيانات." },
          { icon: "shield", title: "أمان مدمج", desc: "تشفير أثناء النقل وتخزين على بنية تحتية محصنة." },
          { icon: "clients", title: "أنت تتحكم", desc: "حدّث ملفك، ألغِ التسويق، أو اطلب حذف بياناتك." },
        ],
        tocLabel: "في هذه الصفحة",
        ctaTitle: "أسئلة حول بياناتك؟",
        ctaDesc: "تواصل مع فريق الخصوصية لطلبات البيانات أو حذف الحساب أو أسئلة السياسة.",
        ctaSecondary: "حذف الحساب",
        ctaSecondaryTo: "/delete-account",
      },
      support: {
        breadcrumb: "الدعم",
        eyebrow: "مركز المساعدة",
        bannerTitle: "إجابات فورية",
        bannerIntro:
          "اسأل مساعد احجزلي أو تصفّح الأسئلة، للعملاء وأصحاب الأعمال في مصر.",
        title: "ساعد نفسك في ثوانٍ",
        intro:
          "استخدم المساعد الذكي لإجابة سريعة، أو افتح الأسئلة بالأسفل. للبريد أو الاتصال، اذهب إلى تواصل.",
        sectionsLabel: "في هذه الصفحة",
        quickDesc: "مساعد ذكي وأسئلة شائعة للعملاء وأصحاب الأعمال.",
        cta: "تصفّح الأسئلة",
        ctaTo: "#support-faqs",
        highlights: [
          { icon: "support", title: "المساعد الذكي", desc: "اسأل عن الحجوزات أو الحساب أو التطبيق" },
          { icon: "articles", title: "الأسئلة", desc: "إجابات قصيرة للعملاء وأصحاب الأعمال" },
          { icon: "clients", title: "للعملاء", desc: "مواعيد، مدفوعات وملفك" },
          { icon: "owners", title: "للأعمال", desc: "الإدراج، اللوحة ودعم الشركاء" },
        ],
        tocLabel: "مساعد احجزلي",
        channelsLabel: "اسأل المساعد",
        channelsLead: "اختر موضوعاً أو اكتب سؤالاً. البريد والهاتف في صفحة تواصل.",
        faqsLabel: "تصفّح الأسئلة",
        faqsLead: "إجابات قصيرة للعملاء وأصحاب الأعمال. افتح سؤالاً بالأسفل.",
        ctaTitle: "تحتاج شخصاً؟",
        ctaDesc: "راسلنا أو اتصل أو أرسل رسالة. نرد خلال يوم عمل.",
        ctaSecondary: "تواصل معنا",
        ctaSecondaryTo: "/contact",
      },
      contact: {
        breadcrumb: "تواصل",
        eyebrow: "تواصل معنا",
        bannerTitle: "نرد. بسرعة.",
        bannerIntro:
          "بريد أو هاتف أو رسالة قصيرة. فريق احجزلي في القاهرة يرد بالعربي أو الإنجليزي.",
        title: "تكلم مع احجزلي",
        intro:
          "حجز، حسابك، أو إضافة صالون. اكتب لنا ونرد خلال يوم عمل.",
        sectionsLabel: "في هذه الصفحة",
        quickDesc: "بريد، هاتف، مواعيد العمل ونموذج رسالة.",
        cta: "أرسل رسالة",
        ctaTo: "#contact-form",
        highlights: [
          { icon: "contact", title: "البريد أولاً", desc: "الأنسب للحجوزات والحساب والتفاصيل" },
          { icon: "phone", title: "اتصل", desc: "للمساعدة العاجلة في ساعات القاهرة" },
          { icon: "clock", title: "رد خلال يوم", desc: "نقرأ كل الرسائل السبت إلى الخميس" },
          { icon: "owners", title: "عملاء وأصحاب أعمال", desc: "صندوق واحد للجميع، نحوّلها للفريق" },
        ],
        emailLabel: "البريد",
        emailValue: "bookwithehgezly@gmail.com",
        emailHint: "أرفق لقطات شاشة إذا تعطل التطبيق.",
        phoneLabel: "الهاتف",
        phoneValue: "+20 111 664 0224",
        phoneHint: "السبت إلى الخميس، 10:00 إلى 20:00 بتوقيت القاهرة.",
        hoursLabel: "المواعيد",
        hoursValue: "السبت إلى الخميس، 10:00 إلى 20:00",
        hoursHint: "الجمعة: البريد فقط. نرد في يوم العمل التالي.",
        hoursExtra: "توقيت القاهرة",
        formTitle: "أرسل رسالة",
        formLead: "يفتح تطبيق البريد عندك بالتفاصيل جاهزة. لا نخزّن شيئاً في هذه الصفحة.",
        nameLabel: "اسمك",
        namePh: "الاسم بالكامل",
        emailFieldLabel: "بريدك",
        emailPh: "you@email.com",
        topicLabel: "الموضوع",
        topics: [
          { value: "booking", label: "حجز أو موعد" },
          { value: "account", label: "حساب أو تسجيل دخول" },
          { value: "business", label: "إضافة أو إدارة نشاط" },
          { value: "payment", label: "مدفوعات أو استرداد" },
          { value: "other", label: "شيء آخر" },
        ],
        messageLabel: "الرسالة",
        messagePh: "ماذا حدث، وماذا تحتاج؟",
        submit: "افتح في البريد",
        nextTitle: "ماذا بعد الإرسال",
        nextSteps: [
          "نقرأ رسالتك في نفس اليوم أو يوم العمل التالي.",
          "الرد يأتي من bookwithehgezly@gmail.com.",
          "عاجل؟ اتصل وجهّز اسم الحجز.",
        ],
        reasonsTitle: "فيمَ نقدر نساعدك",
        reasons: [
          { title: "الحجوزات", desc: "المواعيد، الإلغاء، محلات لم تؤكد." },
          { title: "حسابك", desc: "دخول، كلمة سر، الملف، أو حذف الحساب." },
          { title: "الشركاء", desc: "إضافة صالون، لوحة التحكم، أو الدفعات." },
          { title: "الخصوصية", desc: "طلبات البيانات أو كيف نستخدم معلوماتك." },
        ],
        basedIn: "من القاهرة، مصر",
        basedInDesc: "نبني احجزلي هنا. دعم بالعربي والإنجليزي.",
        followTitle: "تابعنا",
        ctaTitle: "تريد إجابات فورية؟",
        ctaDesc: "الدعم فيه المساعد الذكي والأسئلة الشائعة. من غير انتظار البريد.",
        ctaSecondary: "افتح الدعم",
        ctaSecondaryTo: "/support",
        ctaFaq: "عرض الأسئلة",
      },
      delete: {
        breadcrumb: "حذف الحساب",
        eyebrow: "الحساب والبيانات",
        bannerTitle: "احذف حسابك",
        bannerIntro:
          "اطلب الحذف النهائي. ننتظر 90 يوماً قبل إزالة بياناتك.",
        title: "طلب حذف الحساب",
        intro:
          "أرسل النموذج بالأسفل. نحذف حسابك وبياناتك بعد 90 يوماً من الطلب.",
        sectionsLabel: "في هذه الصفحة",
        quickDesc: "نموذج الطلب، انتظار 90 يوماً، وماذا يحدث بعد ذلك.",
        cta: "إرسال الطلب",
        ctaTo: "#delete-form",
        highlights: [
          { icon: "clock", title: "90 يوماً", desc: "ننتظر قبل الحذف النهائي" },
          { icon: "lock", title: "أكّد أولاً", desc: "اكتب حذف حتى يكون الطلب مقصوداً" },
          { icon: "contact", title: "البريد مطلوب", desc: "نطابق الطلب مع حسابك" },
          { icon: "shield", title: "بياناتك", desc: "اقرأ كيف نتعامل مع المعلومات في الخصوصية" },
        ],
        formTitle: "طلب الحذف",
        formLead: "استخدم البريد المسجّل في احجزلي. الحقول الاختيارية تساعدنا في معالجة الطلب.",
        emailLabel: "البريد الإلكتروني",
        emailPh: "example@email.com",
        nameLabel: "الاسم (اختياري)",
        namePh: "الاسم كما يظهر في الحساب",
        reasonLabel: "السبب (اختياري)",
        reasonPh: "لماذا تريد حذف حسابك؟",
        confirmLabel: "اكتب حذف للتأكيد",
        confirmWord: "حذف",
        submit: "إرسال الطلب",
        submitting: "جاري الإرسال…",
        errorEmail: "البريد الإلكتروني مطلوب",
        errorConfirm: "يرجى كتابة حذف للتأكيد",
        errorGeneric: "حدث خطأ ما",
        successTitle: "تم استلام طلبك.",
        successDesc: "سيتم حذف حسابك نهائياً بعد 90 يوماً. لا يمكن التراجع عن هذا الطلب.",
        nextTitle: "ماذا بعد الإرسال",
        nextSteps: [
          "نتأكد أن البريد يطابق حساباً في احجزلي.",
          "يبقى الحساب حتى تمر 90 يوماً.",
          "بعدها نحذف الحساب والبيانات نهائياً.",
        ],
        noteTitle: "قبل الإرسال",
        noteDesc: "الحجوزات والمحلات المحفوظة وبيانات الملف تُحذف مع الحساب بعد 90 يوماً.",
        ctaTitle: "غيّرت رأيك؟",
        ctaDesc: "يمكنك متابعة استخدام احجزلي، أو قراءة كيف نتعامل مع بياناتك.",
        ctaSecondary: "سياسة الخصوصية",
        ctaSecondaryTo: "/privacy",
        ctaContact: "تواصل معنا",
      },
      ownerLogin: {
        bannerTitle: "احجزلي للأعمال",
        brandHeadline: "أدر صالونك من مكان واحد",
        bannerIntro:
          "الحجوزات والتقويم والفريق والإيرادات تبقى متزامنة — لحظة ما العميل يحجز أونلاين.",
        benefitsTitle: "داخل لوحتك",
        benefits: [
          { icon: "calendar", title: "تقويم مباشر", desc: "شاهد المواعيد الفارغة وجدول اليوم والطلبات الجديدة فوراً." },
          { icon: "history", title: "سجل الحجوزات", desc: "اقبل أو أعد الجدولة أو أكمل المواعيد في ثوانٍ." },
          { icon: "analytics", title: "تحليلات", desc: "تابع الإيرادات والحجوزات وما يحقق النمو." },
        ],
        noAccount: "ليس لديك نشاط بعد؟",
        listBusiness: "أضف نشاطك",
        partnerInfo: "تعرّف على الشراكة",
        credsTitle: "بيانات الدخول المؤقتة",
        credsHint: "احفظ هذه البيانات — يمكنك تغيير كلمة المرور بعد تسجيل الدخول.",
        signingIn: "جاري تسجيل الدخول…",
      },
    },
  },
};
